<template>
  <div class="flex items-center justify-between px-5 py-4 bg-gray-100 border-b">
    <div class="flex items-center">
      <AssigneeDropdown
        :assignee="conversation.assignedTo"
        @onItemClicked="updateAssignee"
      />
      <StatusDropdown
        :status="conversation.status"
        @onItemClicked="updateStatus"
      />
      <TagDropdown
        :selectedTags="conversation.tags"
        :conversationId="conversation.id"
        @tagsSelected="updateTags"
      />
      <div class="ml-6">
        <span
          v-for="(tagId, index) of conversation.tags"
          :key="index"
          class="inline-flex items-center rounded-md bg-green-100 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 border mx-1"
          >{{ getTagName(tagId) }}
          <button
            type="button"
            class="group relative -mr-1 h-4 w-4 rounded-sm hover:bg-green-200"
            @click="removeTags(tagId)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>

            <span class="absolute -inset-1" /></button
        ></span>
      </div>
    </div>
    <!-- <div class="flex items-center">
      <button>
        <svg
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          class="h-6 w-6 text-gray-600"
        >
          <path
            d="M19 9l-7 7-7-7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      <button class="ml-2">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          class="h-6 w-6 text-gray-600"
        >
          <path
            d="M5 16l7-7 7 7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
    </div> -->
  </div>
</template>

<script>
import AssigneeDropdown from "./AssigneeDropdown";
import StatusDropdown from "./StatusDropdown";
import TagDropdown from "./TagDropdown";

export default {
  components: {
    AssigneeDropdown,
    StatusDropdown,
    TagDropdown
  },
  props: {
    conversation: {
      type: Object
    }
  },
  methods: {
    updateAssignee(userId) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "replace",
          value: userId,
          type: "owner"
        }
      });
    },
    getTagName(tagId) {
      return this.$store.getters["Inbox/getTagNameById"](tagId);
    },
    updateStatus(status) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "replace",
          value: status,
          type: "status"
        }
      });
    },
    updateTags(tagIds) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "add",
          value: tagIds,
          type: "tag"
        }
      });
    },
    removeTags(tagId) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "remove",
          value: tagId,
          type: "tags"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
